import React from "react";
import { Grid } from "@mui/material";

const Events: React.FC = () => {
  return <Grid container spacing={2}></Grid>;
};

export default Events;
